import { ConfigActionTypes, DRAWER_COLLAPSED, InitialStateConfig } from './types';

const initialState: InitialStateConfig = {
  drawerCollapsed: false,
};

export const reducerConfig = (state = initialState, action: ConfigActionTypes) => {
  switch (action.type) {
    case DRAWER_COLLAPSED:
      return {
        ...state,
        drawerCollapsed: action.payload,
      };

    default:
      return state;
  }
};
